export default __webpack_public_path__ + "static/media/guadalajara.543aaa3a.png";